module.exports = __webpack_public_path__ + "img/citylink.59be506d.svg";